import { Button } from 'antd';

interface Props {
  value: string | number | null | undefined;
  targetReportCode: string;
  onDrillDown: (reportCode: string, paramValue: string | number) => void;
}

export function DrillDownCellRenderer({ value, targetReportCode, onDrillDown }: Props) {
  if (value == null || value === '') return <span style={{ color: 'var(--color-text-muted)' }}>—</span>;
  return (
    <Button
      type="link"
      size="small"
      style={{ padding: 0, height: 'auto' }}
      onClick={() => onDrillDown(targetReportCode, value)}
    >
      {String(value)}
    </Button>
  );
}
